<template>
  <div class="mainContaner full_w">
    <loading v-show="showLoading"></loading>
    <div v-if="!showLoading">
      <!--content-->
      <div class="cart_content" v-if="!emptyList">
        <div class="content_item" v-for="(item,index) in gameList" :key="index">
          <p class="zt14 black blod">{{item.lotteryActivityName}}<van-button class="fr" :to="{path:'gameTurntable',query:{gameId:item.lotteryActivityId}}" size="small" style="margin-top: 0.5rem;width: 5rem" round color="#EB84AB">立即参与</van-button></p>
          <p class="zt12 black">活动时间:{{formatDate(item.fromDate)}}-{{formatDate(item.thruDate)}}</p>
        </div>
      </div>
      <div class="tc" v-if="emptyList">
        <img style="width: 8rem;margin-top: 3rem" src="@/images/quesheng-copy.png"/>
        <div class="zt14" style="margin-top: 2rem;color:#d4237a">
          暂无游戏活动
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import Vue from 'vue';
  import { storeName,prodCatalogId,severUrl } from '@/router/Constant'
  import { getGameList} from '@/router/api';
  import { setStore,getStore } from '@/utils/mUtil';
  import { Tab, Tabs } from 'vant';
  import { Overlay,PullRefresh,Toast } from 'vant';
  import { Image,Grid,Tabbar,Dialog,Button,Uploader,Tag } from 'vant';
  import { DropdownMenu, DropdownItem } from 'vant';
  import footerView from '../common/footer';
  import loading from '@/components/page/common/loading.vue';
  import refresh from '@/components/page/common/refresh.vue';


  export default {
    name: 'gameList',
    data() {
      return {
        activeMine:0,
        productStoreId:storeName,
        prodCatalogId:prodCatalogId,
        showLoading:false,
        viewIndex:0,
        viewSize:20,
        emptyList:false,
        gameList:[],
        externalLoginKey:getStore('externalLoginKey'),
      }
    },
    components: {
      [Image.name]: Image,
      [Button.name]: Button,
      [PullRefresh.name]: PullRefresh,
      [Tab.name]: Tab,
      [Tabs.name]: Tabs,
      [Grid.name]: Grid,
      [Tabbar.name]: Tabbar,
      [Toast.name]: Toast,
      [Dialog.name]: Dialog,
      [Uploader.name]: Uploader,
      [Overlay.name]:Overlay,
      [DropdownMenu.name]:DropdownMenu,
      [DropdownItem.name]:DropdownItem,
      [Tag.name]:Tag,
      footerView,
      loading,
      refresh,
    },
    methods:{
      async initData() {
        this.getGameListAction()
      },

      getGameListAction(){
        getGameList({externalLoginKey:getStore('externalLoginKey'),openId:getStore('openId')})
          .then(res => {
            console.log(res)
            console.log('getGameList')
            if (!res._ERROR_MESSAGE_){
              if (res.gameList.length > 0) {
                this.gameList = res.gameList
                if (res.gameList.length == 1){
                  this.$router.replace({name:'gameTurntable',query:{gameId:res.gameList[0].lotteryActivityId}})
                }
              } else {
                this.emptyList = true
              }
            } else {
              Toast(res._ERROR_MESSAGE_)
            }
            setTimeout(() => {
              this.showLoading = false;
            }, 1000);
          })
          .catch(err => {
            console.log(err);
          });
      },

      formatDate(value) {
        if(value!=null&&value!=''&&value!=undefined ){
          let date = new Date(value)
          let y = date.getFullYear()
          let MM = date.getMonth() + 1
          MM = MM < 10 ? ('0' + MM) : MM
          let d = date.getDate()
          d = d < 10 ? ('0' + d) : d
          return y + '.' + MM + '.' + d
        }else{
          return ''
        }
      },
      // 数据格式化
      resetScorllView() {
        this.$router.afterEach((to,from, next) => {
          window.scrollTo(0,0)
        })
      },

      onRefresh() {
        setTimeout(() => {
          this.isLoading = false
        }, 1000);

      },

    },

    mounted() {
      this.initData()
      this.resetScorllView();
    },
  }
</script>

<style lang="scss" scoped>

  .mainContaner {
    position: absolute;top: 0;
  }

  .nav_bar {
    background-color: white;padding-top: 0.5rem;position: fixed;top: 0;left: 0;width: 100%;border-bottom: 1px solid #eaeaea;z-index: 101;
  }

  .nav_bar_left_item {
    padding-top: 0.3rem;
  }

  .nav_item_btn {
    width: 1.25rem;height: 1.25rem;
  }

  .nav_bar_search {
    width: 16.3rem;margin: 0 0.4rem;background-color: white;height: 2rem;line-height: 2rem;padding: 0 0.8rem
  }

  .pl_info1 {
    width: 11.68rem;height: 15.625rem;padding-bottom: 0.5rem;border-bottom: 1px solid #eaeaea;
  }

  .pl_info1_img {
    width: 11.68rem;
    height: 11.68rem;
  }

  .pl_info1:nth-child(odd) {
    border-right: 1px solid #eaeaea;
  }

  .pl_info1_title {
    padding: 0 0.1rem;margin:0 0.5rem 0;font-size: 0.75rem;color: #333333;margin-bottom: 0.5rem;
  }

  .pl_info1_price {
    margin-left: 0.5rem;font-size: 0.875rem;color: #F47B33;font-weight: bold;
  }

  .pl_info1_addCart {
    margin-right: 0.5rem;font-size: 0.75rem;color: #999999;
  }

  .cart_content {
    padding: 0 1rem;
    padding-bottom: 3rem;
  }

  .cart_group_item {
    padding-top: 0;
  }

  .group_title {
    margin: 0;padding: 0.5rem 1rem;background-color: #f5f5f5
  }

  .group_promote {
    margin: 0;padding: 0.5rem 1rem;
  }

  .group_promote_tag {
    padding: 0 0.5rem;color: #FF0000;border: 1px solid #FF0000;border-radius: 0.5rem;margin-right: 0.3rem
  }

  .group_item_select {
    height: 5rem;padding: 0 0.5rem 0 0
  }

  .group_item_select_btn {
    width: 1rem;height: 1rem;
  }

  .group_item_img {
    width: 5rem;height: 5rem;
  }

  .group_item_feature {
    margin: 0.3rem 0;width: 14rem;height: 1.3rem;color: #9e9e9e;
  }

  .group_item_name {
    width: 14.5rem;padding: 0 0 0 0.5rem
  }

  .group_item_zengpin_btn {
    color: #999999;
    border: 1px solid #eaeaea;
    padding: 0.05rem 0.5rem;
    border-radius: 1.5rem;
  }

  .group_item_num_btn {
    width: 1.8rem;height: 1.5rem;line-height: 1.4rem;border: 1px solid #eaeaea
  }

  .group_item_val_btn {
    width: 1.5rem;height: 1.3rem;background-color: white;border-style: none;
  }

  .balance_view {
    height: 3rem;width: 100%;position: fixed;bottom: 0;background-color: white;box-shadow: 0px -2px 10px #F0F0F0;
  }

  .all_check_btn {
    line-height: 3rem;width: 5rem;height: 3rem;padding-left: 0.5rem
  }

  .total_price_view {
    margin-left: 0.1rem;color: #F47B33;
  }

  .reduce_disabled_btn {
    color: #eaeaea;
  }

  .base_line {
    height: 3rem;
    background-color: white;
  }

  .content_item {
    background-color: white;padding: 0.7rem 0.5rem;;box-shadow: 0px 1px 17px #F0F0F0;border-radius: 0.2rem;margin: 1rem 0;
  }


  .address_phone {
    margin-left: 2rem;margin-bottom: 0.3rem
  }

  .address_default_tag {
    padding: 0rem 0.5rem;background-color: #F47B33;color: white;border-radius: 0.5rem;margin-top: 0.2rem
  }

  .address_address1 {
    width: 18rem
  }

  .address_detail_icon {
    margin-top: -1rem;width: 0.875rem;height: 0.875rem
  }

  .animate_action {
    transition:all .4s;
  }

  /*商品活动/优惠券*/
  .goods-action-activity-shadow{
    width:100%;
    background:rgba(0,0,0,0.4);
    height: 100%;
    position: fixed;
    display: none;
    z-index: 99;
  }
  .goods-action-activity-content{
    width:100%;
    height:30.25rem;
    background-color: white;
    position: fixed;
    display: block;
    bottom: -31.25rem;
    padding-bottom: 1rem;
    z-index: 99;
  }
  .goods-action-activity-title{
    height: 3rem;
    line-height: 3rem;
    text-align: center;
    font-size:1rem;
    color:#333312;
  }
  .goods-action-activity-content-bottom{
    width:21.4375rem;
    margin:0 auto;
    border-bottom: 1px solid #e5e5e5;
  }
  .goods-action-activity-content-name{
    font-size:1rem;
    color:#333312;
    height: 3rem;
    line-height: 3rem;
  }
  .goods-action-activity-content-list{
    width:100%;
  }
  .goods-action-activity-content-each{
    width:100%;
    height: 6.875rem;
    margin-bottom: 0.3125rem;
  }
  .goods-action-activity-content-each img{
    width:100%;
    height: 100%;
  }
  .goods-action-activity-content-list-left{
    display: inline-block;
    vertical-align: top;
    width:2rem;
  }
  .goods-action-activity-content-list-left img{
    width:1.25rem;
    height:0.90625rem;
  }
  .goods-action-activity-content-list-right{
    display: inline-block;
    vertical-align: top;
    width:calc(100% - 3.5rem);
  }
  .goods-action-activity-content-each-left{
    display: inline-block;
    vertical-align: top;
    width:5rem;
    position: relative;
    top: -5rem;
    left: 2.4rem;
  }
  .goods-action-activity-price{
    color:white;
    font-size: 1.71875rem;
  }
  .goods-action-activity-content-each-right{
    display: inline-block;
    vertical-align: top;
    width:calc(100% - 5rem);
    position:relative;
    top: -8rem;
    left: 8rem;
  }
  .goods-action-activity-content-desc{
    color:#F47B33;
    font-size:0.9375rem;
    margin-bottom: 0.6875rem;
  }
  .goods-action-activity-content-time{
    color:#666;
    font-size:0.625rem;
    margin-bottom: 0.96875rem;
  }
  .goods-action-activity-content-status{
    width:100%;
    height: 1.40625rem;
  }
  .goods-action-activity-content-status-desc{
    color:#999;
    font-size: 0.75rem;
    display: inline-block;
    vertical-align: top;
    width: 7rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow:ellipsis;
    height: 1.40625rem;
    line-height: 1.40625rem;
  }
  .goods-action-activity-content-status-button{
    width:4.6875rem;
    height: 1.40625rem;
    display: inline-block;
    vertical-align: top;
    line-height: 1.40625rem;
  }
  .goods-action-activity-content-status-button button{
    width:100%;
    font-size: 0.75rem;
    color:#F47B33;
    text-align: center;
    line-height: 1.40625rem;
    border-radius:0.703125rem;
    border:1px solid #F47B33;
  }
  .goods-action-activity-desc{
    color:#F47B33;
    font-size:1rem;
  }
  .goods-action-activity-time{
    font-size:0.875rem;
    color:#999;
    line-height: 2rem;
  }

  .coupon_item {
    height: 7rem;
  }

</style>








// WEBPACK FOOTER //
// src/components/page/game/gameList.vue